import { useTranslations } from 'use-intl';

const MINUTE_MS = 60_000;

/** "just now", "5m ago", "3h ago", "2d ago" in the app's language: how long ago an ISO timestamp was. */
export function useRelativeTime() {
  const t = useTranslations('consultantMessages.relative');

  return (iso: string): string => {
    const minutes = Math.floor((Date.now() - new Date(iso).getTime()) / MINUTE_MS);
    if (minutes < 1) return t('justNow');
    if (minutes < 60) return t('minutes', { count: String(minutes) });
    const hours = Math.floor(minutes / 60);
    if (hours < 24) return t('hours', { count: String(hours) });
    return t('days', { count: String(Math.floor(hours / 24)) });
  };
}
